import redondo1 from "../images/redondo_1.jpeg";
import redondo2 from "../images/redondo_2.jpeg";
import redondo3 from "../images/redondo_3.jpeg";
import innovacion from "../images/INNOVACION.jpeg";
import experiencia from "../images/EXPERIENCIA.jpeg";
import transparencia from "../images/TRANSPARENCIA.jpeg";
import car1 from "../images/car1.jpg";
import car2 from "../images/car2.jpg";
import car3 from "../images/car3.jpg";
import { useState, useEffect } from "react";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    { img: car1, title: "Custom Pentesting", text: "Hallamos y convertimos tus debilidades en fortalezas." },
    { img: car2, title: "Control",           text: "Proteja y custodie su información y comunicaciones." },
    { img: car3, title: "Valor",             text: "Generamos valor alineados con los objetivos de su negocio." },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % slides.length);

  return (
    <>
      {/* ── CAROUSEL ──────────────────────────────────────────────────────── */}
      <div style={{ position: "relative", width: "100%", overflow: "hidden" }}>
        <div style={{ position: "relative", height: "400px" }}>
          {slides.map((slide, idx) => (
            <div
              key={idx}
              style={{
                position:   "absolute",
                inset:      0,
                opacity:    idx === currentSlide ? 1 : 0,
                transition: "opacity 0.6s ease",
              }}
            >
              <img
                src={slide.img}
                alt={slide.title}
                style={{ width: "100%", height: "400px", objectFit: "cover" }}
              />
              <div style={{
                position:   "absolute",
                bottom:     "40px",
                left:       "50%",
                transform:  "translateX(-50%)",
                textAlign:  "center",
                color:      "#fff",
                textShadow: "0 2px 6px rgba(0,0,0,0.8)",
              }}>
                <h1>{slide.title}</h1>
                <p>{slide.text}</p>
              </div>
            </div>
          ))}
        </div>

        <button onClick={prevSlide} style={{
          position: "absolute", top: "50%", left: "16px", transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.4)", border: "none", color: "#fff",
          fontSize: "1.5rem", padding: "8px 14px", cursor: "pointer", borderRadius: "4px",
        }}>&#8249;</button>
        <button onClick={nextSlide} style={{
          position: "absolute", top: "50%", right: "16px", transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.4)", border: "none", color: "#fff",
          fontSize: "1.5rem", padding: "8px 14px", cursor: "pointer", borderRadius: "4px",
        }}>&#8250;</button>

        <div style={{ position: "absolute", bottom: "12px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "8px" }}>
          {slides.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentSlide(idx)}
              style={{
                width: "12px", height: "4px", border: "none", cursor: "pointer",
                background: idx === currentSlide ? "#fff" : "rgba(255,255,255,0.5)",
                borderRadius: "2px", padding: 0,
              }}
            />
          ))}
        </div>
      </div>

      {/* ── TRES COLUMNAS: Prevención / Control / Correción ───────────────── */}
      <div className="container mt-4">
        <div className="row justify-content-md-center">

          <div className="col-lg-4">
            <img src={redondo1} height="160" width="160" alt="Prevención" />
            <h2>Prevención</h2>
            <p>Evaluar la efectividad de sus controles reduce el riesgo de padecer un ciberataque o incidente de seguridad.</p>
            <p><button className="btn btn-secondary">Ver mas. »</button></p>
          </div>

          <div className="col-lg-4">
            <img src={redondo2} height="160" width="160" alt="Control" />
            <h2>Control</h2>
            <p>Conocer e inspeccionar el flujo de información a su organización es la clave.</p>
            <p><button className="btn btn-secondary">Ver mas. »</button></p>
          </div>

          <div className="col-lg-4">
            <img src={redondo3} height="160" width="160" alt="Correción" />
            <h2>Correción</h2>
            <p>Análisis, investigación e inteligencia para solucionar las brechas de seguridad de su compañia.</p>
            <p><button className="btn btn-secondary">Ver mas. »</button></p>
          </div>

        </div>

        {/* ── FEATURETTES ─────────────────────────────────────────────────── */}
        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7">
            <h2 className="featurette-heading">Innovación <span className="text-muted">Transformación digital.</span></h2>
            <p className="lead">Acompañamiento a tu organización en soluciones para custodiar y auditar sus activos tecnológicos y de la información.</p>
          </div>
          <div className="col-md-5">
            <img src={innovacion} className="d-block w-100" alt="Innovación" />
          </div>
        </div>

        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7 order-md-2">
            <h2 className="featurette-heading">Experiencia <span className="text-muted">Conocimiento</span></h2>
            <p className="lead">Profesionales jóvenes con experiencia en TIC adquirida en las compañias con mayores retos tecnológicos del país. Conocimientos en tendencias y plataformas alineadas con las necesidades de su negocio.</p>
          </div>
          <div className="col-md-5 order-md-1">
            <img src={experiencia} className="d-block w-100" alt="Experiencia" />
          </div>
        </div>

        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7">
            <h2 className="featurette-heading">Efectividad <span className="text-muted">Transparencia</span></h2>
            <p className="lead">Honestidad y compromiso de nuestra parte para afianzar las relaciones con nuestros clientes y lograr mejores resultados.</p>
          </div>
          <div className="col-md-5">
            <img src={transparencia} className="d-block w-100" alt="Transparencia" />
          </div>
        </div>

        <hr className="featurette-divider" />
      </div>
    </>
  );
};

export default Home;